export const environment = {
  API_URL: "https://api.findify.cloud",
  FILE_URL: "https://api.findify.cloud/uploads",
  IFRAMELY_API_URL: 'https://iframely.findify.cloud',
  API_URL_QA: "https://api.qa.findify.cloud",
  FILE_URL_QA: "https://api.qa.findify.cloud/uploads",
  IFRAMELY_API_URL_QA: 'https://iframely.qa.findify.cloud',
  REACT_APP_PROJECT: 'FINDIFYV2APP',
  PAYPAL_CLIENT_ID: '',
  PAYPAL_CLIENT_SECRET: '',
  PAYPAL_URL: ''
};

export let IS_QA_MODE = false;

export const setQAMODE = (ENABLE_QA_MODE: boolean) => {
  IS_QA_MODE = ENABLE_QA_MODE;
}

export const getApiUrl = () => {
  return IS_QA_MODE ? environment.API_URL_QA : environment.API_URL;
}

export const getFileUrl = () => {
  return IS_QA_MODE ? environment.FILE_URL_QA : environment.FILE_URL;
}

export const getIframelyUrl = () => {
  return IS_QA_MODE ? environment.IFRAMELY_API_URL_QA : environment.IFRAMELY_API_URL;
}